import React from "react";
import { useTranslation } from "react-i18next";
const SpamhausEDROPAdapterSummary = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("i", null, t("spamhaus_edrop_adapter_summary.no_configuration")));
};
export default SpamhausEDROPAdapterSummary;
